import Hero from "../sections/2026/Hero";
import Changes from "../sections/2026/Changes";
import Timeline from "../sections/2026/Timeline";
import Stats from "../sections/2026/Stats";
import Vows from "../sections/2026/Vows";
import OurSong from "../sections/2026/OurSong";
import Gallery from "../sections/2026/Gallery";
import Final from "../sections/2026/Final";

function Site2026() {
  return (
    <div className="site-2026">
      <Hero />
      <Timeline />
      <Changes />
      <Stats />
      <Vows />
      <OurSong />
      <Gallery />
      <Final />
    </div>
  );
}

export default Site2026;
